import './components.css';
import { Link } from 'react-router-dom';

export default function Header() {
    return (
        <div class = 'header'>
            <div class = 'title'>
                <h1>Support and Help Everyone in Need</h1>
            </div>
            <div class = 'header-links'>
                <ul class = 'nav-links'>
                    <li><Link to = '/'>Home</Link></li>
                    <li><Link to = '/contact'>Contact</Link></li>
                    <li><Link to = '/about'>About</Link></li>
                    <li><Link to = 'how-to-get-to-know-god'>How to get to know God</Link></li>
                </ul>
            </div>
        </div>
    );
}